import { render, staticRenderFns } from "./visitreport.vue?vue&type=template&id=24794c70&"
import script from "./visitreport.vue?vue&type=script&lang=js&"
export * from "./visitreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports